import { GetterTree } from 'vuex';
import { FunctionsState, RootState } from './functions-types';

export const getters: GetterTree<FunctionsState, RootState> = {
  skillsFunctions: (state) => state.functions?.body,
  // skillsEmployeeProfile(state): string {
  //   const { user } = state;
  //   console.log('email', user);
  //   console.log('state', state);
  //   const email = (user && user.email) || 'saifi.razique@nile';
  //   console.log('email2', email);
  //   // const firstName = (user && user.firstName) || '';
  //   // const lastName = (user && user.lastName) || '';
  //   // return `${firstName} ${lastName}`;
  //   return email;
  // },
};
